import { React } from 'react';
import { Accountpage } from '../components';

export default function Account() {
    return (
        <div className="account">                      
            <Accountpage/>
        </div>        
    )
};